module.exports = __webpack_public_path__ + "img/chpc_about_industry_01.a6b7a95a.png";